import { render, staticRenderFns } from "./pay-slip2.vue?vue&type=template&id=be0f3ad0&"
import script from "./pay-slip2.vue?vue&type=script&lang=js&"
export * from "./pay-slip2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports